import { render, staticRenderFns } from "./ImpersonationLayout.vue?vue&type=template&id=cc3b3112&"
import script from "./ImpersonationLayout.vue?vue&type=script&lang=ts&"
export * from "./ImpersonationLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports